// src/components/skillsData.js
const skillsData = [
  {
    name: "Programming Skills",
    level: "Advanced",
    yearsExperience: "3 yrs",
    image: "https://example.com/python.png",
    tags: ["Programming", "Data Science"],
    badges: [{ name: "Certified AI Developer", colorScheme: "blue" }],
    items: [
      "Python",
      "PyTorch",
      "TensorFlow",
      "OpenCV",
      "Pydicom",
      "Sklearn",
      "Pandas",
      "Git",
      "Colab",
      "Hugging Face",
      "ITKSnap",
    ],
  },
  {
    name: "AI/ML Techniques",
    level: "Advanced",
    yearsExperience: "2 yrs",
    image: "https://example.com/ai-tech.png",
    tags: ["AI/ML", "Radiology", "Medical Imaging"],
    badges: [{ name: "AI Expert", colorScheme: "green" }],
    items: [
      "Neural networks",
      "Segmentation algorithms",
      "Radiomics analysis",
      "Feature extraction",
    ],
  },
  {
    name: "Certifications",
    level: "",
    yearsExperience: "",
    image: "https://example.com/certifications.png",
    tags: ["Certifications", "Education"],
    badges: [{ name: "Certified AI in Medicine", colorScheme: "purple" }],
    items: [
      "American Board of Artificial Intelligence in Medicine certified clinician for AI in Medicine",
      "AI for Medicine Specialization by DeepLearning.AI",
      "Ethics of AI in Radiology from Radiological Society of North America (RSNA)",
      "Deep Learning and Medical Imaging Certificate Summer School IIT Kharagpur",
      "Basic Course in Biomedical Research by ICMR-National Institute of Epidemiology",
    ],
  },
  {
    name: "Tools and Software",
    level: "Intermediate",
    yearsExperience: "2 yrs",
    image: "https://example.com/tools.png",
    tags: ["Software", "Tools", "Medical Imaging"],
    badges: [{ name: "Certified Tool Expert", colorScheme: "yellow" }],
    items: ["3D Slicer", "ITK-SNAP", "MATLAB", "Mimics", "Rhino"],
  },
];

export default skillsData;
